// Analytics tab › Connections. Renders the SHIPPED BiConnectionsPanel in
// its inline variant — the spec §5 two-pane hub (list pane + form pane)
// filling the section, no modal. Create / edit / test / delete, per-type
// forms, write-only secrets and Browse tables all live in the panel.
import BiConnectionsPanel from '@/components/connections/BiConnectionsPanel'

export default function ConnectionsSection({
  project, onChanged,
}: {
  project: string
  /** Notifies the shell so the Overview inventory refreshes. */
  onChanged?: () => void
}) {
  return (
    <div style={{ height: '100%', minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      <div style={{ flex: 1, minHeight: 0 }}>
        <BiConnectionsPanel
          project={project}
          variant="inline"
          onChanged={onChanged}
        />
      </div>
    </div>
  )
}
